import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrandDropdownComponent } from './brand-dropdown.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [BrandDropdownComponent],
  exports: [BrandDropdownComponent],
})
export class BrandDropdownModule { }
